<template>
  <div class="h-screen bg-surface-50">
    <NavBarWorkspace />
    <main class="pl-64 h-full">
      <div class="h-full p-3 pl-0">
        <div
          id="main-content-window"
          class="h-full bg-white rounded-md border overflow-auto studio-scrollbar relative"
        >
          <slot />
        </div>
      </div>
    </main>
  </div>
</template>

<script setup></script>
